import { track } from 'modules/core/lib/Tracking'
import { events } from './events'

type Origin = 'manual' | 'one'
type AttachmentContext = 'detail' | 'create'

// Navigation
export const trackGoToTicketing = () => track(events.goToTicketing)
export const trackGoToTicketingInsights = () => track(events.goToTicketingInsights)

// Ticket creation
export const trackOpenCreateTicketDialog = () => track(events.openCreateTicketDialog)
export const trackCreateTicket = (props: {
  priority: string
  has_description: boolean
  has_attachments: boolean
  attachments_count: number
  origin: Origin
}) => track(events.createTicket, props)

// Ticket detail & updates
export const trackOpenTicketDetail = (props: { status: string; priority: string }) =>
  track(events.openTicketDetail, props)

export const trackUpdateTicketStatus = (props: { previous_status: string; new_status: string }) =>
  track(events.updateTicketStatus, props)

export const trackUpdateTicketPriority = (props: {
  previous_priority: string
  new_priority: string
}) => track(events.updateTicketPriority, props)

export const trackUpdateTicketAssigneeTeam = () => track(events.updateTicketAssigneeTeam)
export const trackUpdateTicketAssigneeMember = () => track(events.updateTicketAssigneeMember)

// Comments & attachments
export const trackAddTicketComment = (props: { origin: Origin }) =>
  track(events.addTicketComment, props)

export const trackAddTicketAttachment = (props: { context: AttachmentContext }) =>
  track(events.addTicketAttachment, props)

export const trackDownloadTicketAttachment = () => track(events.downloadTicketAttachment)

// List interactions
export const trackFilterTickets = (props: { filter_type: string }) =>
  track(events.filterTickets, props)

export const trackSearchTickets = () => track(events.searchTickets)

export const trackSelectTicketPreset = (props: { preset: string }) =>
  track(events.selectTicketPreset, props)

export const trackSortTickets = (props: { sort_field: string; sort_order: string }) =>
  track(events.sortTickets, props)

// Insights
export const trackChangeInsightsTeamFilter = (props: { team_id: string }) =>
  track(events.changeInsightsTeamFilter, props)

export const trackChangeInsightsPeriodFilter = (props: { period: string }) =>
  track(events.changeInsightsPeriodFilter, props)
